import React from "react";
import { QuestionShape } from "@ignitesales/neuro-application/src/shapes/index.mjs";
import classNames from "classnames";
import NumberInput from "@ignitesales/react-number-format";
import QuestionText from "@ignitesales/neuro-application/src/components/questions/QuestionText.jsx";
import { FormattedHTMLMessage, useIntl } from "react-intl";
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent.jsx";

const Number = (props) => {
  const { className, valueChanged, question, value: { value } = {} } = props;

  const intl = useIntl();

  const classes = classNames(className, {
    "number-format": true,
  });

  const icon = (
    <MessageIfPresent id={`${props.appkey}.icon`}>
      <div className="text-center pb-4 py-4 question__icon">
        <FormattedHTMLMessage id={`${props.appkey}.icon`} />
      </div>
    </MessageIfPresent>
  );

  return (
    <section className={classes}>
      {icon ? icon : null}
      <QuestionText question={question} />
      <NumberInput
        onChange={valueChanged}
        plus={<i className="fa fa-plus" />}
        minus={<i className="fa fa-minus" />}
        step={
          question.hasOwnProperty("attributes") &&
          question.attributes.hasOwnProperty("step")
            ? question.attributes.step
            : 1
        }
        value={value}
        min={
          question.attributes && question.attributes.min
            ? question.attributes.min
            : 0
        }
        max={
          question.attributes && question.attributes.max
            ? question.attributes.max
            : 10000000
        }
        format={
          question.attributes && question.attributes.format
            ? question.attributes.format
            : "number"
        }
        pad={
          <span>
            <i className="fa fa-calculator" />
          </span>
        }
        padElementId="root"
        header={intl.formatMessage({ id: question.appkey })}
      />
    </section>
  );
};

Number.propTypes = {
  data: QuestionShape,
};

export default Number;
